import React, { useState } from "react";
import { Button, Col, ListGroup, Row } from "react-bootstrap";
import VisitCheckListSubtitle from "./VisitCheckListSubtitle";
import { useDispatch, useSelector } from "react-redux";
import { FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import { AiOutlineSend } from "react-icons/ai";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import Message from "./Message";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";

const VisitCheckListForm = ({
  visitCheckLists,
  setVisitCheckLists,
  missedCheckLists,
  referesh,
  setReferesh,
  visitId,
  setShowEdit,
  clinic,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const updateCheckLists = async () => {
    // update physician note action
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visitId}/updateVisitCheckLists`,
        { visitCheckLists },
        config,
      );
      setVisitCheckLists(data.updatedVisitCheckLists);
      if (data.missedOptions.length > 0) {
        dispatch({ type: CLINIC_DETAILS_RESET });
      }
      setShowEdit(false);
      setLoading(false);
      notify({
        title: "Physician Note Update",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };
  return (
    <>
      <div>
        {" "}
        <ListGroup className="p-3">
          {visitCheckLists?.map((vs, order) => {
            const XCheckList = clinic?.clinicCheckLists?.find(
              (cc) => cc._id.toString() === vs.titleId.toString(),
            );
            return (
              <div className="mb-2">
                {order !== 0 && <hr className="flex-grow-1" />}
                <Row className="text-center text-primary ">
                  <Col className="mb-2 col-10">
                    {XCheckList?.title.toUpperCase()}
                  </Col>
                  <Col className="text-right col-auto">
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        if (
                          window.confirm(
                            "You will delete this list. Are you sure?",
                          )
                        ) {
                          setVisitCheckLists(
                            visitCheckLists.filter(
                              (vs) =>
                                vs.titleId?.toString() !==
                                XCheckList?._id?.toString(),
                            ),
                          );
                        }
                      }}
                    >
                      <FaTrashAlt />
                    </Button>
                  </Col>
                </Row>
                {vs.subtitles.map((st) => {
                  const XSubtitle = XCheckList?.subtitles.find(
                    (sct) => sct._id === st.subtitleId,
                  );
                  return (
                    <div key={st._id || st.idx}>
                      {st.subtitleId && (
                        <Row className="px-3 my-2">
                          <Col className="bg-secondary text-white col align-self-center p-2">
                            {XSubtitle?.subtitle}
                          </Col>
                          <Col>
                            {/* <pre>{JSON.stringify(st, null, 2)}</pre> */}
                            <VisitCheckListSubtitle
                              titleId={XCheckList?.titleId}
                              options={XSubtitle?.options}
                              subtitle={st}
                              referesh={referesh}
                              setReferesh={setReferesh}
                            />
                          </Col>
                        </Row>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </ListGroup>
        {/* {missedCheckLists?.map((ms, order) => (
          <Button
            key={order}
            className="btn-secondary w-100 my-2"
            onClick={() =>
              setVisitCheckLists([
                ...visitCheckLists,
                {
                  idx: Math.random(),
                  titleId: ms._id,
                  subtitles: ms.subtitles.map((st) => ({
                    idx: Math.random(),
                    subtitleId: st._id,
                    selectedOptionId:
                      st.options.filter((o) => !o.isHide)[0]?._id || "", //make first option as default
                    selectedOption:
                      st.options.filter((o) => !o.isHide)[0]?.label || "",
                  })),
                },
              ])
            }
          >
            {" "}
            <FaPlusCircle /> {`Add ${ms.title}`}
          </Button>
        ))} */}
        {missedCheckLists?.map((ms, order) => {
          const currentFirstTwo = ms.title?.split(" ").slice(0, 2).join(" ");
          const previousFirstTwo = missedCheckLists[order - 1]?.title
            ?.split(" ")
            .slice(0, 2)
            .join(" ");

          const showLine = order === 0 || currentFirstTwo !== previousFirstTwo;

          return (
            <div key={order}>
              {showLine && (
                <div className="d-flex align-items-center my-2">
                  <hr className="flex-grow-1" />
                  <span className="mx-3 fw-bold">{currentFirstTwo}</span>
                  <hr className="flex-grow-1" />
                </div>
              )}

              <Button
                className="btn-secondary w-100 my-2"
                onClick={() =>
                  setVisitCheckLists((prev) => [
                    ...prev,
                    {
                      idx: Math.random(),
                      titleId: ms._id,
                      subtitles: ms.subtitles.map((st) => ({
                        idx: Math.random(),
                        subtitleId: st._id,
                        selectedOptionId:
                          st.options.filter((o) => !o.isHide)[0]?._id || "",
                        selectedOption:
                          st.options.filter((o) => !o.isHide)[0]?.label || "",
                      })),
                    },
                  ])
                }
              >
                <FaPlusCircle /> {ms.title}
              </Button>
            </div>
          );
        })}
      </div>
      <div>
        {error && (
          <Message
            children={`Update Checklist error: ${error}`}
            variant={`danger`}
            setMessage={setError}
          />
        )}
        <Row className="width-100 justify-content-end my-2">
          <Col className="mr-2 col-auto">
            <Button
              variant="outline-success"
              onClick={() => updateCheckLists()}
            >
              <AiOutlineSend /> Update Checklists
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VisitCheckListForm;
